import { forwardRef, InputHTMLAttributes } from 'react'

import styles from './Input.module.scss'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string
}

/** Styled input component */
const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { className, ...rest } = props
  return <input ref={ref} className={`${styles.input} ${className ? className : ''}`} {...rest} />
})

Input.displayName = 'Input'

export default Input
